<template>
  <Modal class-name="vertical-center-modal" v-model="isModal" title="取消总监" width="300">
    <div class="form-wrapper">
      <div class="tip-wrap">
        <div>{{content}}</div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn cancel-btn" @click="handelCancel">否</span>
        <span class="btn confirm-btn" @click="handelSubmit">是</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
import { Modal, Spin } from 'view-design'
import member from  '@/javaApi/kfc/member.js'
const memberModel = new member()
export default {
  name: "CancelDirector",
  components: {
    Modal,
    Spin
  },
  data: function() {
    return {
      isModal: false,
      loading: false,
      content: '取消总监身份后，该用户将不再享受分红。是否取消该用户总监身份？',
      type:0,
      sourceData:{},
    }
  },
  methods: {
    init: function(isModal, row) {
      this.loading = true
      this.sourceData = row
      this.isModal = isModal
      this.loading = false
    },
    handelSubmit:function(){
      let param = {
        uuid :this.sourceData.uuid
      }
      let that = this
      this.loading = true
      memberModel.userCancelJunior(param).then(response=>{
        let res = response.data
        that.loading = false
        if(res.code == 200){
          that.$message.success('取消成功')
          that.isModal = false
          that.$emit('refresh')
        } else {
          let message = res.message?res.message:'系统异常,请稍后再试'
          that.$message.error(message)
        }
      }).catch(error=>{
        that.loading = false
        console.log(error)
        if(error != 'token invalid'){
          that.$message.error('系统异常请稍后再试')
        }
      })
    },
    handelCancel: function (){
      this.isModal = false
    }
  }
}
</script>

<style scoped>
>>>.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

>>>.vertical-center-modal .ivu-modal {
  top: 0;
  width: 300px;
}

>>>.vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 12px 18px 30px 18px;
  text-align: right;
}
.form-wrapper .tip-wrap{
  padding: 20px;
}
.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.footer-wrapper .btn {
  display: inline-block;
  border-radius: 4px;
  margin: 0 15px;
  padding: 0px 30px;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.footer-wrapper .btn.confirm-btn {
  background: #D63036;
  color: #fff;
}

.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
  background: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/member/modal/CancelDirector.vue